import {
  CalendarDatum,
  CalendarTooltipProps,
  ResponsiveTimeRange,
  TimeRangeDayData,
} from "@nivo/calendar";
import moment, { Moment } from "moment";
import { useTheme } from "@mui/material";
import React from "react";
import useChartTheme from "./chartTheme";

type Props = {
  dataInicio: Moment;
  dataFim: Moment;
  data: CalendarioData[];
  direction?: "vertical" | "horizontal";
  formatTooltip?: (point: CalendarTooltipProps) => JSX.Element;
  onClick?: (
    data: TimeRangeDayData & CalendarioData,
    event: React.MouseEvent<SVGRectElement, MouseEvent>
  ) => void;
};
export default function Calendario({
  data,
  dataInicio,
  dataFim,
  direction,
  formatTooltip,
  onClick,
}: Props) {
  const theme = useTheme();
  const chartTheme = useChartTheme();
  const onClickInterno = (
    data: TimeRangeDayData,
    event: React.MouseEvent<SVGRectElement, MouseEvent>
  ) => {
    if (onClick) onClick(data as TimeRangeDayData & CalendarioData, event);
  };
  return (
    <ResponsiveTimeRange
      theme={chartTheme}
      data={data}
      from={dataInicio.format("YYYY-MM-DD")}
      to={dataFim.format("YYYY-MM-DD")}
      monthLegend={(_year: number, _month: number, date: Date) =>
        moment(date).format("MMMM")
      }
      // Célula do heatmap é indicador, não preenchimento de botão: entra na
      // TINTA do accent. O `primary.main` sólido dá 1,7:1 contra a célula vazia
      // (`divider`) no dark — os dias com movimento somem no calendário.
      // Ver DESIGN.md → accent vs. accent-ink.
      colors={[theme.palette.accentInk]}
      margin={{
        top: 0,
        right: 0,
        bottom: 0,
        left: direction === "vertical" ? 20 : 0,
      }}
      weekdayTicks={[]}
      weekdayLegendOffset={0}
      square={false}
      dayRadius={4}
      dayBorderWidth={4}
      // O default do nivo é preto puro: o "respiro" entre os dias tem que ser
      // a própria superfície do card, não uma grade preta.
      dayBorderColor={theme.palette.background.paper}
      direction={direction}
      tooltip={formatTooltip}
      onClick={onClickInterno}
      emptyColor={theme.palette.divider}
    />
  );
}

export interface CalendarioData extends CalendarDatum {
  aux?: any;
}
